webpackJsonp([76],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/graphql-ruby-3-mutations.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"html": "<h3>Mutation for Creating Links</h3>\n<p>Setting up mutations is as easy as queries, following a very similar process.</p>\n<p>All <a href=\"http://graphql.org/learn/queries/#mutations\">GraphQL mutations</a> start from a root type called <strong>Mutation</strong>.</p>\n<p>This type is auto generated in the file <code>app/graphql/types/mutation_type.rb</code>:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-ruby\"  path=\".../graphql-ruby/app/graphql/types/mutation_type.rb\"  nocopy=\"false\"><code><span class=\"token keyword\">module</span> <span class=\"token constant\">Types</span>\n  <span class=\"token keyword\">class</span> <span class=\"token class-name\">MutationType</span> <span class=\"token operator\">&lt;</span> <span class=\"token constant\">Types</span><span class=\"token punctuation\">:</span><span class=\"token symbol\">:BaseObject</span>\n    <span class=\"token comment\" spellcheck=\"true\"># TODO: remove me</span>\n    field <span class=\"token symbol\">:test_field</span><span class=\"token punctuation\">,</span> <span class=\"token builtin\">String</span><span class=\"token punctuation\">,</span> null<span class=\"token punctuation\">:</span> <span class=\"token keyword\">false</span><span class=\"token punctuation\">,</span>\n      description<span class=\"token punctuation\">:</span> <span class=\"token string\">\"An example field added by the generator\"</span>\n    <span class=\"token keyword\">def</span> test_field\n      <span class=\"token string\">\"Hello World\"</span>\n    <span class=\"token keyword\">end</span>\n  <span class=\"token keyword\">end</span>\n<span class=\"token keyword\">end</span>\n</code></pre>\n      </div>\n<p>This type is a placeholder for all GraphQL mutations.</p>\n<p>To prevent any error when you first start your GraphQL project, it is generated with a dummy <code>testField</code> field.<br>\nYou will be able to remove it as soon as you add your own mutation below.</p>\n<p>The mutation type is automatically exposed in your schema:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-ruby\"  path=\".../graphql-ruby/app/graphql/graphql_tutorial_schema.rb\"  nocopy=\"false\"><code><span class=\"token keyword\">class</span> <span class=\"token class-name\">GraphqlTutorialSchema</span> <span class=\"token operator\">&lt;</span> <span class=\"token constant\">GraphQL</span><span class=\"token punctuation\">:</span><span class=\"token symbol\">:Schema</span>\n  query <span class=\"token constant\">Types</span><span class=\"token punctuation\">:</span><span class=\"token symbol\">:QueryType</span>\n  mutation <span class=\"token constant\">Types</span><span class=\"token punctuation\">:</span><span class=\"token symbol\">:MutationType</span>\n<span class=\"token keyword\">end</span>\n</code></pre>\n      </div>\n<h3>Resolvers with Arguments</h3>\n<p>Now add a resolver for <code>createLink</code>.</p>\n<p>For this purpose, you’ll use a <a href=\"http://graphql-ruby.org/mutations/mutation_classes.html\">Mutation class</a>, as mentioned earlier.</p>\n<Instruction>\n<p>Create a new file - <code>app/graphql/mutations/base_mutation.rb</code>:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-ruby\"  path=\".../graphql-ruby/app/graphql/mutations/base_mutation.rb\"  nocopy=\"false\"><code><span class=\"token keyword\">module</span> <span class=\"token constant\">Mutations</span>\n  <span class=\"token comment\" spellcheck=\"true\"># This class is used as a parent for all mutations, and it is the place to have common utilities </span>\n  <span class=\"token keyword\">class</span> <span class=\"token class-name\">BaseMutation</span> <span class=\"token operator\">&lt;</span> <span class=\"token constant\">GraphQL</span><span class=\"token punctuation\">:</span><span class=\"token symbol\">:Schema</span><span class=\"token punctuation\">:</span><span class=\"token symbol\">:Mutation</span>\n    null <span class=\"token keyword\">false</span>\n  <span class=\"token keyword\">end</span>\n<span class=\"token keyword\">end</span>\n</code></pre>\n      </div>\n</Instruction>\n<Instruction>\n<p>Create a new file - <code>app/graphql/mutations/create_link.rb</code>:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-ruby\"  path=\".../graphql-ruby/app/graphql/mutations/create_link.rb\"  nocopy=\"false\"><code><span class=\"token keyword\">module</span> <span class=\"token constant\">Mutations</span>\n  <span class=\"token keyword\">class</span> <span class=\"token class-name\">CreateLink</span> <span class=\"token operator\">&lt;</span> <span class=\"token constant\">BaseMutation</span>\n    <span class=\"token comment\" spellcheck=\"true\"># arguments passed to the `resolved` method</span>\n    argument <span class=\"token symbol\">:description</span><span class=\"token punctuation\">,</span> <span class=\"token builtin\">String</span><span class=\"token punctuation\">,</span> required<span class=\"token punctuation\">:</span> <span class=\"token keyword\">true</span>\n    argument <span class=\"token symbol\">:url</span><span class=\"token punctuation\">,</span> <span class=\"token builtin\">String</span><span class=\"token punctuation\">,</span> required<span class=\"token punctuation\">:</span> <span class=\"token keyword\">true</span>\n\n    <span class=\"token comment\" spellcheck=\"true\"># return type from the mutation</span>\n    type <span class=\"token constant\">Types</span><span class=\"token punctuation\">:</span><span class=\"token symbol\">:LinkType</span>\n\n    <span class=\"token keyword\">def</span> <span class=\"token function\">resolve</span><span class=\"token punctuation\">(</span>description<span class=\"token punctuation\">:</span> <span class=\"token keyword\">nil</span><span class=\"token punctuation\">,</span> url<span class=\"token punctuation\">:</span> <span class=\"token keyword\">nil</span><span class=\"token punctuation\">)</span>\n      <span class=\"token constant\">Link</span><span class=\"token punctuation\">.</span>create<span class=\"token operator\">!</span><span class=\"token punctuation\">(</span>\n        description<span class=\"token punctuation\">:</span> description<span class=\"token punctuation\">,</span>\n        url<span class=\"token punctuation\">:</span> url<span class=\"token punctuation\">,</span>\n      <span class=\"token punctuation\">)</span>\n    <span class=\"token keyword\">end</span>\n  <span class=\"token keyword\">end</span>\n<span class=\"token keyword\">end</span>\n</code></pre>\n      </div>\n</Instruction>\n<Instruction>\n<p>Then expose this mutation in <code>app/graphql/types/mutation_type.rb</code>:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-ruby\"  path=\".../graphql-ruby/app/graphql/types/mutation_type.rb\"  nocopy=\"false\"><code><span class=\"token keyword\">module</span> <span class=\"token constant\">Types</span>\n  <span class=\"token keyword\">class</span> <span class=\"token class-name\">MutationType</span> <span class=\"token operator\">&lt;</span> <span class=\"token constant\">BaseObject</span>\n    field <span class=\"token symbol\">:create_link</span><span class=\"token punctuation\">,</span> mutation<span class=\"token punctuation\">:</span> <span class=\"token constant\">Mutations</span><span class=\"token punctuation\">:</span><span class=\"token symbol\">:CreateLink</span>\n  <span class=\"token keyword\">end</span>\n<span class=\"token keyword\">end</span>\n</code></pre>\n      </div>\n</Instruction>\n<h3>Testing with Playground</h3>\n<p>To test, just restart the server again and use the new mutation with GraphiQL:</p>\n<p><img src=\"http://i.imgur.com/pHNRZlG.png\"></p>\n<h3>Testing with Unit Test</h3>\n<p>It’s a good practice in Ruby to unit test your resolver objects.</p>\n<p>Here is an example of <code>Resolvers::CreateLink</code> test:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-ruby\"  path=\".../graphql-ruby/test/graphql/mutations/create_link_test.rb\"  nocopy=\"false\"><code><span class=\"token keyword\">require</span> <span class=\"token string\">'test_helper'</span>\n\n<span class=\"token keyword\">class</span> <span class=\"token class-name\">Mutations</span><span class=\"token punctuation\">:</span><span class=\"token symbol\">:CreateLinkTest</span> <span class=\"token operator\">&lt;</span> <span class=\"token constant\">ActiveSupport</span><span class=\"token punctuation\">:</span><span class=\"token symbol\">:TestCase</span>\n  <span class=\"token keyword\">def</span> <span class=\"token function\">perform</span><span class=\"token punctuation\">(</span>user<span class=\"token punctuation\">:</span> <span class=\"token keyword\">nil</span><span class=\"token punctuation\">,</span> <span class=\"token operator\">*</span><span class=\"token operator\">*</span>args<span class=\"token punctuation\">)</span>\n    <span class=\"token constant\">Mutations</span><span class=\"token punctuation\">:</span><span class=\"token symbol\">:CreateLink</span><span class=\"token punctuation\">.</span><span class=\"token keyword\">new</span><span class=\"token punctuation\">(</span>object<span class=\"token punctuation\">:</span> <span class=\"token keyword\">nil</span><span class=\"token punctuation\">,</span> context<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span><span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span><span class=\"token function\">resolve</span><span class=\"token punctuation\">(</span>args<span class=\"token punctuation\">)</span>\n  <span class=\"token keyword\">end</span>\n\n  test <span class=\"token string\">'create a new link'</span> <span class=\"token keyword\">do</span>\n    link <span class=\"token operator\">=</span> <span class=\"token function\">perform</span><span class=\"token punctuation\">(</span>\n      url<span class=\"token punctuation\">:</span> <span class=\"token string\">'http://example.com'</span><span class=\"token punctuation\">,</span>\n      description<span class=\"token punctuation\">:</span> <span class=\"token string\">'description'</span><span class=\"token punctuation\">,</span>\n    <span class=\"token punctuation\">)</span>\n\n    assert link<span class=\"token punctuation\">.</span>persisted<span class=\"token operator\">?</span>\n    assert_equal link<span class=\"token punctuation\">.</span>description<span class=\"token punctuation\">,</span> <span class=\"token string\">'description'</span>\n    assert_equal link<span class=\"token punctuation\">.</span>url<span class=\"token punctuation\">,</span> <span class=\"token string\">'http://example.com'</span>\n  <span class=\"token keyword\">end</span>\n<span class=\"token keyword\">end</span>\n</code></pre>\n      </div>\n<p>You can run the tests with the following command:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-bash\"   nocopy=\"false\"><code>bundle <span class=\"token function\">exec</span> rails <span class=\"token function\">test</span>\n</code></pre>\n      </div>",
				"fields": {
					"slug": "/graphql-ruby/3-mutations/"
				},
				"excerpt": "Mutation for Creating Links Setting up mutations is as easy as queries, following a very similar process. All  GraphQL mutations  start from...",
				"frontmatter": {
					"title": "Mutations",
					"videoId": null,
					"videoAuthor": null,
					"parent": "/opt/build/repo/content/backend/graphql-ruby/3-mutations.md absPath of file",
					"question": null,
					"answers": null,
					"correctAnswer": null,
					"description": "Learn best practices for implementing GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground.",
					"pageTitle": "Implementing Mutations with a Ruby GraphQL Server Tutorial"
				}
			},
			"mds": {
				"edges": [
					{
						"node": {
							"frontmatter": {
								"title": "Get started with your favorite technology",
								"description": null
							},
							"fields": {
								"slug": "/choose/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding users",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/1-adding-users/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding new Snap settings to code",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/0-adding-new-Snap-settings-to-code/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "aws",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/4-aws/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "apache",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/2-apache/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "custom css themes",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/10-custom-css-themes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "It was great having you!",
								"description": null
							},
							"fields": {
								"slug": "/success/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "archive and delete",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/3-archive-and-delete/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "azure",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/5-azure/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "backup",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/6-backup/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "caddy webserver config",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/7-caddy-webserver-config/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloud foundry",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/8-cloud-foundry/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloudron",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/9-cloudron/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with Elixir & Absinthe and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
							},
							"fields": {
								"slug": "/graphql-elixir/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with Elixir & Absinthe as well as best practices for defining the GraphQL schema."
							},
							"fields": {
								"slug": "/graphql-elixir/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Learn best practices for implementing GraphQL mutations with Absinthe & Elixir. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-elixir/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with Elixir & Absinthe and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-elixir/4-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Learn how to define the GraphQL schema with Absinthe, implement query resolvers in Elixir and test your queries in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-elixir/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with graphql-yoga, Node.js & Prisma and best practices for authentication, filtering, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-js/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with Node.js & Express as well as best practices for defining the GraphQL schema."
							},
							"fields": {
								"slug": "/graphql-js/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Query",
								"description": "Learn how to define a GraphQL schema, implement query resolvers with Node.js and test your queries in a GraphQL Playground."
							},
							"fields": {
								"slug": "/graphql-js/2-a-simple-query/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Adding a Database",
								"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma and connected to the server via GraphQL bindings."
							},
							"fields": {
								"slug": "/graphql-js/4-adding-a-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Mutation",
								"description": "Learn best practices for implementing GraphQL mutations with graphql-js, Node.js & Prisma. Test your implementation in a GraphQL Playground."
							},
							"fields": {
								"slug": "/graphql-js/3-a-simple-mutation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connecting Server and Database with the Prisma Client",
								"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma and connected to the server via GraphQL bindings."
							},
							"fields": {
								"slug": "/graphql-js/5-connecting-server-and-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime GraphQL Subscriptions",
								"description": "Learn how to implement GraphQL subscriptions with Node.js, Express & Prisma to add realtime functionality to an app."
							},
							"fields": {
								"slug": "/graphql-js/7-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices for implementing authentication and authorization with Node.js, Express & Prisma."
							},
							"fields": {
								"slug": "/graphql-js/6-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering, Pagination & Sorting",
								"description": "Learn how to add filtering and pagination capabilities to a GraphQL API with Node.js, Express & Prisma."
							},
							"fields": {
								"slug": "/graphql-js/8-filtering-pagination-and-sorting/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with Node.js and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-js/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Building a Server with GraphQL and Graphene"
							},
							"fields": {
								"slug": "/graphql-python/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Setting up a Django Graphene Project"
							},
							"fields": {
								"slug": "/graphql-python/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "Tutorial Summary"
							},
							"fields": {
								"slug": "/graphql-python/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Creating Data With Mutations"
							},
							"fields": {
								"slug": "/graphql-python/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Creating Your First Queries"
							},
							"fields": {
								"slug": "/graphql-python/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Authenticating on GraphQL"
							},
							"fields": {
								"slug": "/graphql-python/4-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Links and Voting",
								"description": "Enable Users to create Links and to Vote on them"
							},
							"fields": {
								"slug": "/graphql-python/5-links-and-voting/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"description": "Handling Errors on GraphQL"
							},
							"fields": {
								"slug": "/graphql-python/6-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"description": "Filtering GraphQL Queries"
							},
							"fields": {
								"slug": "/graphql-python/7-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Simple Pagination with Graphene"
							},
							"fields": {
								"slug": "/graphql-python/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Relay",
								"description": "Using Relay on Graphene"
							},
							"fields": {
								"slug": "/graphql-python/9-relay/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with graphql-java and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
							},
							"fields": {
								"slug": "/graphql-java/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with graphql-java and best practices for defining the GraphQL schema in this tutorial."
							},
							"fields": {
								"slug": "/graphql-java/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn best practices for implementing limit-offset pagination in a GraphQL API using query arguments with a Node.js & Express GraphQL server."
							},
							"fields": {
								"slug": "/graphql-java/10-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Alternative approaches to schema development",
								"description": "Learn about an alternative approach to developing schemas with graphl-java with graphql-spqr"
							},
							"fields": {
								"slug": "/graphql-java/11-alternative-approaches/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with graphql-java and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-java/12-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Learn how to define the GraphQL schema with graphql-java, implement query resolvers in Java and test your queries in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-java/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Learn best practices for implementing GraphQL mutations with graphql-java & Java. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-java/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connectors",
								"description": "Learn how to write connectors in Java to load data from MongoDB with graphql-java and a Java GraphQL server."
							},
							"fields": {
								"slug": "/graphql-java/4-connectors/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices for implementing email-password authentication on a GraphQL Server written in Java."
							},
							"fields": {
								"slug": "/graphql-java/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations",
								"description": "Learn best practices for implementing advanced GraphQL mutations with Java and graphql-java. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-java/6-more-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Subscriptions",
								"description": "Learn how to implement server-side GraphQL subscriptions with Java to add realtime functionality to an app."
							},
							"fields": {
								"slug": "/graphql-java/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"description": "Learn best practices for validation of input arguments and implementing error handling in GraphQL with Java, Node.js & Express."
							},
							"fields": {
								"slug": "/graphql-java/7-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"description": "Learn best practices for implementing filters in a GraphQL API using query arguments with a Java GraphQL server."
							},
							"fields": {
								"slug": "/graphql-java/9-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with graphql-ruby and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
							},
							"fields": {
								"slug": "/graphql-ruby/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with graphql-ruby and best practices for defining the GraphQL schema."
							},
							"fields": {
								"slug": "/graphql-ruby/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Learn how to define the GraphQL schema with graphql-ruby, implement query resolvers in Ruby and use a GraphiQL Playground to test your queries."
							},
							"fields": {
								"slug": "/graphql-ruby/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Learn best practices for implementing GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-ruby/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices for implementing email-password authentication on a GraphQL Server written in Ruby."
							},
							"fields": {
								"slug": "/graphql-ruby/4-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connecting Nodes",
								"description": "Learn best practices for implementing advanced GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-ruby/5-connecting-nodes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"description": "Learn best practices for validation of input arguments and implementing error handling in GraphQL with Ruby."
							},
							"fields": {
								"slug": "/graphql-ruby/6-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"description": "Learn best practices for implementing filters in a GraphQL API using query arguments with a Ruby GraphQL server."
							},
							"fields": {
								"slug": "/graphql-ruby/7-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn best practices for implementing limit-offset pagination in a GraphQL API using query arguments with Ruby GraphQL server."
							},
							"fields": {
								"slug": "/graphql-ruby/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/graphql-scala/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "In this chapter will be described how to setup the HTTP server, install all dependencies and setup the database."
							},
							"fields": {
								"slug": "/graphql-scala/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with graphql-ruby & Ruby and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-ruby/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "The first query",
								"description": "In this chapter you will learn last steps of preparation, add graphiql console for easy debugging and at the end, run your first query."
							},
							"fields": {
								"slug": "/graphql-scala/2-preparing-first-query/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Handling Arguments",
								"description": "In this chapter you will learn how to use arguments and how to handle them and pass to the business logic."
							},
							"fields": {
								"slug": "/graphql-scala/3-handling_arguments/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Custom Scalars",
								"description": "In this chapter Link model will get an additional field to store date and time. You will learn how to handle such custom types and use scalars."
							},
							"fields": {
								"slug": "/graphql-scala/5-custom_scalars/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deferred Resolvers",
								"description": "In this chapter you will learn how to improve performance with deferred resolvers."
							},
							"fields": {
								"slug": "/graphql-scala/4-deferred_resolvers/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Interfaces",
								"description": "In this chapter we will introduce two additional models. We show the most common parts and extract those as an interface. This time you will work alone."
							},
							"fields": {
								"slug": "/graphql-scala/6-interfaces/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Relations",
								"description": "In this chapter you will learn how to connect models with relations. You will also learn how to prepare fetchers to use either relations or ids to get entities."
							},
							"fields": {
								"slug": "/graphql-scala/7-relations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "In this chapter you will learn how to add data to the database."
							},
							"fields": {
								"slug": "/graphql-scala/8-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Sangria's Middleware allows pre-processing queries. Gather all useful data in the following subqueries."
							},
							"fields": {
								"slug": "/graphql-scala/9-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding new Snap settings to code",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/0-adding-new-Snap-settings-to-code/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding users",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/1-adding-users/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "custom css themes",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/10-custom-css-themes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "apache",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/2-apache/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "archive and delete",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/3-archive-and-delete/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "aws",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/4-aws/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "azure",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/5-azure/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "backup",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/6-backup/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "caddy webserver config",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/7-caddy-webserver-config/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloud foundry",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/8-cloud-foundry/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloudron",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/9-cloudron/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, Angular & Apollo Client. You'll use angular-cli for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/angular-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with angular-cli and the backend with Graphcool."
							},
							"fields": {
								"slug": "/angular-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deploying",
								"description": "Learn how to deploy an application built with Angular and Graphcool through Surge.sh."
							},
							"fields": {
								"slug": "/angular-apollo/10-deploying/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading link-items",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your Angular components."
							},
							"fields": {
								"slug": "/angular-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with Angular & Apollo Client you learned how to build a production-ready Hackernews clone using angular-cli & Graphcool."
							},
							"fields": {
								"slug": "/angular-apollo/11-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's service injected in the component to define and send mutations."
							},
							"fields": {
								"slug": "/angular-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": "Learn how to use Angular Router  together with GraphQL and Apollo Client to implement navigation in an Angular app."
							},
							"fields": {
								"slug": "/angular-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in an Angular app with Graphcool."
							},
							"fields": {
								"slug": "/angular-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your Angular components."
							},
							"fields": {
								"slug": "/angular-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/angular-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & Angular. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/angular-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, React & Apollo Client. Use create-react-app for the frontend and graphql-yoga & Prisma for the backend."
							},
							"fields": {
								"slug": "/react-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a Angular app. The Graphcool API exposes the required arguments for lists."
							},
							"fields": {
								"slug": "/angular-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Prisma."
							},
							"fields": {
								"slug": "/react-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with React & Apollo Client you learned how to build a production-ready Hackernews clone using create-react-app & Prisma."
							},
							"fields": {
								"slug": "/react-apollo/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's `<Mutation />` component to define and send mutations."
							},
							"fields": {
								"slug": "/react-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your React components."
							},
							"fields": {
								"slug": "/react-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": "Learn how to use react-router 4 together with GraphQL and Apollo Client to implement navigation in a React app. Each route will be represented as a `Link`."
							},
							"fields": {
								"slug": "/react-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in a React app with Prisma."
							},
							"fields": {
								"slug": "/react-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your React components."
							},
							"fields": {
								"slug": "/react-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Prisma provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/react-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & React. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/react-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a React app. The Prisma API exposes the required arguments for lists."
							},
							"fields": {
								"slug": "/react-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a production-ready Hackernews clone with GraphQL, React & Relay. You'll use create-react-app for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/react-relay/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Graphcool."
							},
							"fields": {
								"slug": "/react-relay/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL Fragments and Relay's QueryRenderer to load data from a server and display it in your React components."
							},
							"fields": {
								"slug": "/react-relay/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how to use Relay Modern's new Mutation API to send mutations to a GraphQL server. With Relay Modern you can also update the cache directly after the mutation."
							},
							"fields": {
								"slug": "/react-relay/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": null
							},
							"fields": {
								"slug": "/react-relay/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Relay to provide an email-and-password-based login in a React app with Graphcool."
							},
							"fields": {
								"slug": "/react-relay/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Relay Modern & React. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/react-relay/7-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Relay Modern's imperative API to update the cache after a GraphQL mutation. The updates will automatically end up in your React components."
							},
							"fields": {
								"slug": "/react-relay/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement cursor-based pagination with GraphQL and Relay Modern using `PaginationContainer`. Relay uses the concept of connections to represent lists."
							},
							"fields": {
								"slug": "/react-relay/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with React & Relay Modern you learned how to build a production-ready Hackernews clone using create-react-app & Graphcool."
							},
							"fields": {
								"slug": "/react-relay/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Clients",
								"description": "Learn about GraphQL clients, like Relay and Apollo Client, and the features they provide, such as caching, schema validation and query/view colocation."
							},
							"fields": {
								"slug": "/advanced/0-clients/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More GraphQL Concepts",
								"description": "Learn about advanced concepts of the GraphQL language like fragments, query arguments, aliases, interfaces and more SDL features"
							},
							"fields": {
								"slug": "/advanced/2-more-graphql-concepts/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Server",
								"description": "Learn about the major concepts of GraphQL servers, how it executes GraphQL queries with resolver functions and batches multiple requests."
							},
							"fields": {
								"slug": "/advanced/1-server/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Tooling and Ecosystem",
								"description": "Learn about the GraphQL ecosystem and its awesome tooling like the GraphiQL playgrounds or self-generating docs through introspection."
							},
							"fields": {
								"slug": "/advanced/3-tooling-and-ecosystem/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Security",
								"description": "Learn about different security aspects and strategies for GraphQL, such as timeouts, maximum query depth, query complexity and throttling."
							},
							"fields": {
								"slug": "/advanced/4-security/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Common Questions",
								"description": "Answer common GraphQL questions about server-side caching, authentication, authorization, error handling, offline usage and more."
							},
							"fields": {
								"slug": "/advanced/5-common-questions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, VueJS & Apollo Client. You'll use vue-cli for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/vue-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your VueJS components."
							},
							"fields": {
								"slug": "/vue-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with VueJS & Apollo Client you learned how to build a production-ready Hackernews clone using vue-cli & Graphcool."
							},
							"fields": {
								"slug": "/vue-apollo/11-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's `mutate` method to define and send mutations."
							},
							"fields": {
								"slug": "/vue-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": "Learn how to use vue-router together with GraphQL and Apollo Client to implement navigation in a VueJS app."
							},
							"fields": {
								"slug": "/vue-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with vue-cli and the backend with Graphcool."
							},
							"fields": {
								"slug": "/vue-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deploying",
								"description": "Learn how to deploy an application built with VueJS and Graphcool through Surge.sh."
							},
							"fields": {
								"slug": "/vue-apollo/10-deploying/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in a VueJS app with Graphcool."
							},
							"fields": {
								"slug": "/vue-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your VueJS components."
							},
							"fields": {
								"slug": "/vue-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/vue-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & VueJS. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/vue-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn all about GraphQL and why it is an API technology that's superior to REST. It is not only for React & Javascript developers but can be used for any API."
							},
							"fields": {
								"slug": "/basics/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "GraphQL is the better REST",
								"description": "Learn why GraphQL is a more efficient and flexible alternative to REST APIs. It has a strong type system and avoids frontend issues like over- and underfetching."
							},
							"fields": {
								"slug": "/basics/1-graphql-is-the-better-rest/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Core Concepts",
								"description": "Learn about the basic GraphQL language concepts, such as Queries, Mutations, Subscriptions and the GraphQL Schema & SDL. Try them out in your own sandbox."
							},
							"fields": {
								"slug": "/basics/2-core-concepts/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, Ember, and Apollo Client. You'll use Ember and ember-apollo-client for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/ember-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Big Picture (Architecture)",
								"description": "Learn about different architectural use cases of GraphQL and the major components on the backend and the frontend, like resolver functions and client libraries."
							},
							"fields": {
								"slug": "/basics/3-big-picture/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with ember-cli, ember-apollo-client, and the backend with Graphcool."
							},
							"fields": {
								"slug": "/ember-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your React components."
							},
							"fields": {
								"slug": "/ember-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Navigation",
								"description": "Learn how to use Ember components together with GraphQL and Apollo Client to implement navigation in an Ember app."
							},
							"fields": {
								"slug": "/ember-apollo/4-navigation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use `ember-apollo-client` to send mutations."
							},
							"fields": {
								"slug": "/ember-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your Ember app."
							},
							"fields": {
								"slug": "/ember-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/ember-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with Ember & Apollo Client you learned how to build a production-ready Hackernews clone using ember-apollo-client & Graphcool."
							},
							"fields": {
								"slug": "/ember-apollo/8-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a VueJS app. The Graphcool API exposes the required arguments for lists."
							},
							"fields": {
								"slug": "/vue-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in an Ember app with Graphcool."
							},
							"fields": {
								"slug": "/ember-apollo/5-authentication/"
							}
						}
					}
				]
			}
		},
		"pathContext": {
			"slug": "/graphql-ruby/3-mutations/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---graphql-ruby-3-mutations-729b5a94f941ebbf4ddf.js